import { Button, Form, Input, Space } from "antd";
import { SuspendFilterInputType } from "./SuspendPage";
import * as ewcms from "../EWCMS/styleMaster";

const defaultBtnStyle = ewcms.defaultBtnStyle;

type SuspendFilterFormProps = {
  searchAppointmentByStaffNo: (value: SuspendFilterInputType) => void;
  setStaffNoInput: (value: string) => void;
  limit: number;
  offset: number;
};

const SuspendAppointmentFilterForm = (props: SuspendFilterFormProps) => {
  const [form] = Form.useForm();
  const { searchAppointmentByStaffNo, setStaffNoInput, limit, offset } = props;

  const onFinish = (value: SuspendFilterInputType) => {
    const newInput: string = value.staffNoInput;
    setStaffNoInput(newInput);
    searchAppointmentByStaffNo({ staffNoInput: newInput, limit, offset });
  };

  const onFinishFailed = (failValue: any) => {};

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <div style={{ display: "flex" }}>
        <Form.Item
          name="staffNoInput"
          label=""
          rules={[
            { type: "string", warningOnly: true },
            { type: "string", min: 6, message: 'Staff Number must be 6 characters.' },
            { type: "string", max: 6, message: 'Staff Number must be 6 characters.' },
          ]}
          style={{ width: "20%", marginRight: "15px" }}
        >
          <Input placeholder="Search Staff Number" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button
              className={defaultBtnStyle + " cust-button-height"}
              type="primary"
              htmlType="submit"
            >
              Search
            </Button>
          </Space>
        </Form.Item>
      </div>
    </Form>
  );
};

export default SuspendAppointmentFilterForm;
